import { gsap } from 'gsap'

class Field {
	constructor(field) {
		this.field = field.querySelector('.field__item')
		this.placeholder = field.querySelector('.field__placeholder')

		this.setAnimation()

		this.field.addEventListener('focus', () => this.timeline.play())
		this.field.addEventListener('blur', () => {
			if (this.field.value.length === 0) {
				this.timeline.reverse()
			}
		})
	}

	setAnimation() {
		this.timeline = gsap
			.timeline({ paused: true })
			.to(this.placeholder, {
				y: '-100%',
				x: '-10%',
				scale: 0.8,
				duration: 0.2
			})
	}
}

const fields = []

document.querySelectorAll('.field').forEach((item, key) => {
	if (item.querySelector('.field__placeholder')) {
		fields[key] = new Field(item)
	}
})

export default fields
